import { Button, styled, useTheme } from "@mui/material";
import { useState } from "react";
import { ClipLoader } from "react-spinners";

type FooterProps = {
  handleClose: () => void;
  handleSubmit: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => Promise<void>;
  loading?: boolean;
};

export const Footer = ({ handleClose, handleSubmit, loading }: FooterProps) => {
  const theme = useTheme();

  const [localLoading, setLocalLoading] = useState(false);

  return (
    <Container>
      <Button variant="outlined" onClick={handleClose}>
        Cancel
      </Button>
      <Button
        startIcon={
          loading || localLoading ? (
            <ClipLoader color={theme.palette.primary.dark} size={20} />
          ) : null
        }
        variant="contained"
        color="primary"
        type="button"
        onClick={async (e) => {
          e.preventDefault();
          setLocalLoading(true);
          await handleSubmit(e);
          setLocalLoading(false);
        }}
        disabled={loading || localLoading}
      >
        {loading ? "Saving..." : "Save"}
      </Button>
    </Container>
  );
};

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  padding: "16px",
  borderTop: `1px solid ${theme.palette.divider}`,
  position: "relative",
  width: "100%",
  gap: "16px",
  backgroundColor: theme.palette.background.default,
  zIndex: 10,
  boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
  flexShrink: 0,
}));
